export const resolveImgToSmall = imgUrl => {
  if (!imgUrl) return ""
  const hasQuery = imgUrl.indexOf("?") > -1
  const smallQuery = "x-oss-process=style/w640"
  let result = imgUrl
  if (hasQuery) {
    result += "&" + smallQuery
  } else {
    result += "?" + smallQuery
  }
  return result
}
